import { NavLink, Route, Routes } from 'react-router-dom';
import { Products } from './pages/Products';
import { Deals } from './pages/Deals';
import { Discounts } from './pages/Discounts';
import { PriceDrops } from './pages/PriceDrops';
import { Watchlist } from './pages/Watchlist';
import { ProductDetail } from './pages/ProductDetail';

export function App() {
  return (
    <div className="app">
      <nav className="nav">
        <h1>Price Tracker PE</h1>
        <NavLink to="/" end>Productos</NavLink>
        <NavLink to="/ofertas">Ofertas</NavLink>
        <NavLink to="/deals">Descuentos reales</NavLink>
        <NavLink to="/bajadas">Bajaron de precio</NavLink>
        <NavLink to="/seguidos">Seguidos</NavLink>
      </nav>
      <Routes>
        <Route path="/" element={<Products />} />
        <Route path="/ofertas" element={<Discounts />} />
        <Route path="/deals" element={<Deals />} />
        <Route path="/bajadas" element={<PriceDrops />} />
        <Route path="/seguidos" element={<Watchlist />} />
        <Route path="/p/:id" element={<ProductDetail />} />
      </Routes>
    </div>
  );
}
